import { useTableOrientationStore } from '../../../store/useTableOrientationStore'

// Přepínač orientace datové tabulky (normální ↔ transponovaná). Vizuál shodný s chipsy
// TimeZonePickeru (px-2 py-0.5 text-xs rounded border), aby seděl do stejné úrovně.
// Stav drží useTableOrientationStore per-produkt (slug).
export function TableOrientationToggle({ slug, className = '' }) {
  const orientation = useTableOrientationStore((s) => s.getOrientation(slug))
  const toggle = useTableOrientationStore((s) => s.toggle)
  const transposed = orientation === 'transposed'

  return (
    <button
      type="button"
      onClick={() => toggle(slug)}
      title={transposed ? 'Zpět na normální tabulku' : 'Transponovat tabulku (prohodit řádky a sloupce)'}
      className={`shrink-0 px-2 py-0.5 text-xs rounded border transition-colors ${
        transposed
          ? 'bg-gray-700 text-white border-gray-700'
          : 'bg-white text-gray-600 border-gray-300 hover:border-gray-500'
      } ${className}`}
    >
      Transponovat
    </button>
  )
}
